// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-ribbon-wrapper {
  height: 100%;
}

.UnitCardList_unit-card-list-badge__G40w2 {
  background-color: var(--accent-color-dark);
  color: var(--accent-color);
}
.UnitCardList_unit-card-list-badge__G40w2.UnitCardList_no-level__LcQ-a {
  display: none;
}

.UnitCardList_unit-card-list__a\\+nH6 {
  display: flex;
  padding: 20px;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}
.UnitCardList_unit-card-list__a\\+nH6 div:empty {
  display: none;
}
.UnitCardList_unit-card-list__top__85nEB {
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
}
.UnitCardList_unit-card-list__body__sCuxk {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.UnitCardList_unit-card-list__body--item__qz8b6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.UnitCardList_unit-card-list__body--item--title__EpH\\+- {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.UnitCardList_unit-card-list__body--item--value__fh6O9 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  align-self: stretch;
  color: var(--grey-text);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.UnitCardList_unit-card-list__body__left__I3Z8D {
  display: flex;
  padding-right: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 300px;
  min-width: 300px;
  flex-shrink: 0;
}
.UnitCardList_unit-card-list__body__right__caWEC {
  flex: 1 1;
  padding-left: 16px;
  border-left: 1px solid var(--accent-color-medium);
}
.UnitCardList_unit-card-list__bottom__zMrnG {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_link__bzvpt {
  cursor: pointer;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_link__bzvpt:hover {
  text-decoration: underline;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_avatar__6gg3g {
  width: 60px;
  aspect-ratio: 1/1;
  border-radius: 8px;
  object-fit: cover;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-name__o7gF8 {
  color: var(--explore-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  /* 100% */
  letter-spacing: 0.4px;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-name--wrapper__Oryj6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-name--wrapper--link__W1kxN {
  flex: 1 1;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_entity-actions__Wn0Ji {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_entity-actions__Wn0Ji .MuiButton-root {
  box-sizing: border-box;
  min-width: 130px;
  min-height: 36px;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_favorite-btn__EivU3 {
  display: none;
  text-transform: uppercase;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_statistics__RDlf2 .UnitCardList_statistic__ImezG {
  display: flex;
  align-items: center;
  gap: 4px;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_statistics__RDlf2 .UnitCardList_statistic__ImezG svg {
  min-width: 32px;
  height: 32px;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_statistics__RDlf2 .UnitCardList_statistic__ImezG svg path {
  stroke: var(--accent-color-medium);
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_keywords__A-L4l {
  max-height: 76px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_keywords__A-L4l span {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_keywords__A-L4l .UnitCardList_keywords--item__r0COz {
  display: flex;
  padding: 6px 12px;
  align-items: center;
  border-radius: 20px;
  background: var(--light-grey);
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-shadow: none;
  text-transform: initial;
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_keywords__A-L4l .UnitCardList_keywords--item__r0COz.UnitCardList_clickable__ym0XD {
  background: var(--accent-color-light);
  color: var(--text-1);
}
.UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_keywords__A-L4l .UnitCardList_keywords--item__r0COz.UnitCardList_clickable__ym0XD:hover {
  background: var(--accent-color);
  color: var(--text-0);
}

@media only screen and (max-width: 480px) {
  .UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_avatar__6gg3g {
    width: 40px;
    border-radius: 8px;
  }
  .UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-name__o7gF8 {
    font-size: 16px;
    font-weight: 500;
  }
  .UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-name--wrapper__Oryj6 {
    margin-bottom: 0;
  }
  .UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_keywords__A-L4l span:first-child {
    display: none;
  }
  .UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-card-list__body__sCuxk {
    flex-direction: column;
    gap: 8px;
  }
  .UnitCardList_unit-card-list__a\\+nH6 .UnitCardList_unit-card-list__body__right__caWEC {
    max-width: initial;
    padding-left: 0;
    border-left: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/UnitCardList/UnitCardList.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,0CAAA;EACA,0BAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,aAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAF;AAGI;EACE,aAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAHJ;AAME;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAJN;AAMM;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAOM;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALR;AASI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAPN;AAUI;EACE,SAAA;EACA,kBAAA;EACA,iDAAA;AARN;AAYE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAVJ;AAaE;EACE,eAAA;AAXJ;AAaI;EACE,0BAAA;AAXN;AAeE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAbJ;AAgBE;EACE,2BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;AAdJ;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAdN;AAgBM;EACE,SAAA;AAdR;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAjBJ;AAmBI;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AAjBN;AAqBE;EACE,aAAA;EACA,yBAAA;AAnBJ;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArBN;AAuBM;EACE,eAAA;EACA,YAAA;AArBR;AAuBQ;EACE,kCAAA;AArBV;AA2BE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAzBJ;AA2BI;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzBN;AA6BM;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA3BR;AA6BQ;EACE,qCAAA;EACA,oBAAA;AA3BV;AA6BU;EACE,+BAAA;EACA,oBAAA;AA3BZ;;AAmCA;EAEI;IACE,WAAA;IACA,kBAAA;EAjCJ;EAoCE;IACE,eAAA;IACA,gBAAA;EAlCJ;EAoCI;IACE,gBAAA;EAlCN;EAyCI;IACE,aAAA;EAvCN;EA4CI;IACE,sBAAA;IACA,QAAA;EA1CN;EA4CM;IACE,kBAAA;IACA,eAAA;IACA,iBAAA;EA1CR;AACF","sourcesContent":[":global(.ant-ribbon-wrapper) {\n  height: 100%;\n}\n\n.unit-card-list-badge {\n  background-color: var(--accent-color-dark);\n  color: var(--accent-color);\n\n  &.no-level {\n    display: none;\n  }\n}\n\n.unit-card-list {\n  display: flex;\n  padding: 20px;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n\n  div {\n    &:empty {\n      display: none;\n    }\n  }\n\n  &__top {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  &__body {\n    display: flex;\n    padding: 10px;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-self: stretch;\n\n    &--item {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 4px;\n      align-self: stretch;\n\n      &--title {\n        color: var(--grey-text);\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n\n      &--value {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n        overflow: hidden;\n        align-self: stretch;\n        color: var(--grey-text);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n\n    &__left {\n      display: flex;\n      padding-right: 16px;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      width: 300px;\n      min-width: 300px;\n      flex-shrink: 0;\n    }\n\n    &__right {\n      flex: 1;\n      padding-left: 16px;\n      border-left: 1px solid var(--accent-color-medium);\n    }\n  }\n\n  &__bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  .link {\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .avatar {\n    width: 60px;\n    aspect-ratio: 1/1;\n    border-radius: 8px;\n    object-fit: cover;\n  }\n\n  .unit-name {\n    color: var(--explore-color);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    /* 100% */\n    letter-spacing: 0.4px;\n\n    &--wrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex: 1;\n\n      &--link {\n        flex: 1;\n      }\n    }\n  }\n\n  .entity-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n\n    :global(.MuiButton-root) {\n      box-sizing: border-box;\n      min-width: 130px;\n      min-height: 36px;\n    }\n  }\n\n  .favorite-btn {\n    display: none;\n    text-transform: uppercase;\n  }\n\n  .statistics {\n    .statistic {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n\n      svg {\n        min-width: 32px;\n        height: 32px;\n\n        path {\n          stroke: var(--accent-color-medium);\n        }\n      }\n    }\n  }\n\n  .keywords {\n    max-height: 76px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    span {\n      color: var(--grey-text);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    .keywords {\n      &--item {\n        display: flex;\n        padding: 6px 12px;\n        align-items: center;\n        border-radius: 20px;\n        background: var(--light-grey);\n        color: var(--grey-text);\n        text-align: center;\n        font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n        font-size: 0.85rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        box-shadow: none;\n        text-transform: initial;\n\n        &.clickable {\n          background: var(--accent-color-light);\n          color: var(--text-1);\n\n          &:hover {\n            background: var(--accent-color);\n            color: var(--text-0);\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .unit-card-list {\n    .avatar {\n      width: 40px;\n      border-radius: 8px;\n    }\n\n    .unit-name {\n      font-size: 16px;\n      font-weight: 500;\n\n      &--wrapper {\n        margin-bottom: 0;\n      }\n    }\n\n    .keywords {\n      // max-height: 56px;\n\n      span:first-child {\n        display: none;\n      }\n    }\n\n    .unit-card-list {\n      &__body {\n        flex-direction: column;\n        gap: 8px;\n\n        &__right {\n          max-width: initial;\n          padding-left: 0;\n          border-left: none;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit-card-list-badge": `UnitCardList_unit-card-list-badge__G40w2`,
	"no-level": `UnitCardList_no-level__LcQ-a`,
	"unit-card-list": `UnitCardList_unit-card-list__a+nH6`,
	"unit-card-list__top": `UnitCardList_unit-card-list__top__85nEB`,
	"unit-card-list__body": `UnitCardList_unit-card-list__body__sCuxk`,
	"unit-card-list__body--item": `UnitCardList_unit-card-list__body--item__qz8b6`,
	"unit-card-list__body--item--title": `UnitCardList_unit-card-list__body--item--title__EpH+-`,
	"unit-card-list__body--item--value": `UnitCardList_unit-card-list__body--item--value__fh6O9`,
	"unit-card-list__body__left": `UnitCardList_unit-card-list__body__left__I3Z8D`,
	"unit-card-list__body__right": `UnitCardList_unit-card-list__body__right__caWEC`,
	"unit-card-list__bottom": `UnitCardList_unit-card-list__bottom__zMrnG`,
	"link": `UnitCardList_link__bzvpt`,
	"avatar": `UnitCardList_avatar__6gg3g`,
	"unit-name": `UnitCardList_unit-name__o7gF8`,
	"unit-name--wrapper": `UnitCardList_unit-name--wrapper__Oryj6`,
	"unit-name--wrapper--link": `UnitCardList_unit-name--wrapper--link__W1kxN`,
	"entity-actions": `UnitCardList_entity-actions__Wn0Ji`,
	"favorite-btn": `UnitCardList_favorite-btn__EivU3`,
	"statistics": `UnitCardList_statistics__RDlf2`,
	"statistic": `UnitCardList_statistic__ImezG`,
	"keywords": `UnitCardList_keywords__A-L4l`,
	"keywords--item": `UnitCardList_keywords--item__r0COz`,
	"clickable": `UnitCardList_clickable__ym0XD`
};
export default ___CSS_LOADER_EXPORT___;
